<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Communication</div>
        <span class="grey--text">Send Confirmation Email/SMS to the client</span>
      </div>
      <v-spacer></v-spacer>
      <v-btn flat icon @click="doClose()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-if="computeCanSendEmail || computeCanSendSMS">
      <message :messages="messages"></message>
      <form>
        <v-layout row wrap>
          <v-flex xs6 v-if="computeCanSendEmail">
            <v-checkbox v-model="commForm.sendEmail" label="Send Email" :hint="'Email will be sent to: ' + email" persistent-hint></v-checkbox>
          </v-flex>
          <v-flex xs6 v-if="computeCanSendSMS">
            <v-checkbox v-model="commForm.sendSMS" label="Send SMS" :hint="'SMS will be sent to: ' + mobileNo" persistent-hint></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mt-3">
          <v-btn color="red darken-1" flat="flat" @click.native="doClose()" :loading="loading">Cancel</v-btn>
          <v-btn color="primary" flat="flat" @click.native="doSend" :loading="loading">Send</v-btn>
        </v-layout>
      </form>
    </v-card-text>
    <v-divider v-if="computeCanSendEmail || computeCanSendSMS"></v-divider>
    <v-card-text v-if="commsLogs && commsLogs.length > 0">
      <v-subheader>Previous Communication Logs</v-subheader>
      <template v-for="(commLog, index) in commsLogs">
        <v-layout row wrap :key="commLog.sendDT" class="pa-3">
          <v-flex xs6>
            <div>Send By: {{commLog.name}}</div>
            <div class="grey--text">{{formatDT(commLog.sendDT)}}</div>
          </v-flex>
          <v-flex xs6>
            <v-layout row wrap>
              <v-flex xs6>
                <span>Email</span>
                <span v-if="commLog.sendEmail">
                  <v-icon color="green">mdi-check</v-icon>
                </span>
                <span v-else>
                  <v-icon color="red">mdi-close</v-icon>
                </span>
              </v-flex>
              <v-flex xs6>
                <span>SMS</span>
                <span v-if="commLog.sendSMS">
                  <v-icon color="green">mdi-check</v-icon>
                </span>
                <span v-else>
                  <v-icon color="red">mdi-close</v-icon>
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider :key="index"></v-divider>
      </template>
    </v-card-text>
    <v-card-text v-else>
      There is no previous Communication record
    </v-card-text>
  </v-card>
</template>

<script>
import { AGENCY_QUOTATION_COMMSLOG } from '@/store/types'
import { formatDisplayDateTime } from '@/utils/date'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      commForm: {
        sendEmail: false,
        sendSMS: false
      },
      loading: false
    }
  },
  computed: {
    commsLogs() {
      return this.$store.state.agency.quotation.commonInfo.commsLogs
    },
    mobileNo() {
      return this.$store.state.agency.quotation.commonForm.applicant.appMobileNo
    },
    email() {
      return this.$store.state.agency.quotation.commonForm.applicant.appEmail
    },
    status() {
      return this.$store.state.agency.quotation.commonInfo.statusCode
    },
    computeCanSendSMS() {
      if (this.checkStatus() && this.canSendSMS && this.mobileNo) {
        // Cannot send SMS if there is no Mobile No.
        return true
      }
      return false
    },
    computeCanSendEmail() {
      if (this.checkStatus() && this.canSendEmail && this.email) {
        return true
      }
      return false
    }
  },
  methods: {
    checkStatus() {
      // For all proposal right now, only IF/PO can send comms
      if (this.status && (this.status === 'IF' || this.status === 'PO')) {
        return true
      }
      return false
    },
    formatDT(dt) {
      return formatDisplayDateTime(dt)
    },
    doClose() {
      this.$emit('close')
    },
    async doSend() {
      this.resetMessages()
      if (this.commForm.sendEmail || this.commForm.sendSMS) {
        const apiUrl = this.$store.state.agency.quotationSettings.menu.sendComms
        if (apiUrl) {
          try {
            this.loading = true
            const passObj = {
              proposalNo: this.$store.state.agency.quotation.commonForm.proposalNo,
              sendEmail: this.commForm.sendEmail,
              sendSMS: this.commForm.sendSMS
            }
            const result = await this.$http.post(apiUrl, passObj)

            this.notify(result.data)
            this.$store.commit(AGENCY_QUOTATION_COMMSLOG, result.data.data)
            this.doClose()
            this.loading = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.fullMessage(data)
            }
            this.loading = false
          }
        } else {
          this.errorMessage('Invalid API URL')
        }
      } else {
        this.errorMessage('You need to select one of the following options')
      }
    }
  },
  props: {
    canSendEmail: {
      type: Boolean,
      default: false
    },
    canSendSMS: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>
</style>
